// Case studies built ONLY from verified facts: project data + client-approved review quotes.
import { REVIEWS } from "@/data/reviewsData";
import { getExpoBySlug } from "@/data/clientsData";

const RAW = [
  {
    slug: "kexun-smartgen-gce-smm-hamburg-2026",
    review: 0,
    expo: "smm-hamburg",
    client: "KEXUN · SmartGen · GCE",
    title: "Twin-brand marine power stand at SMM Hamburg 2026",
    stand: "Stall B5.135 · Hamburg Messe und Congress",
    brief: "Three maritime power brands needed one shared stand at SMM Hamburg, the world's leading maritime trade fair, with each brand clearly readable from the aisle.",
    delivered: [
      "3D concept showing a twin-brand layout under one structure",
      "Fabrication, graphics and installation at Hamburg Messe",
      "Handover a day before opening, matching the approved 3D render",
      "Stagehook crew on standby for the full show week",
    ],
  },
  {
    slug: "kyb-aapex-las-vegas-2025",
    review: 1,
    expo: "aapex-vegas",
    client: "KYB",
    title: "A 10×10 inline booth for KYB at AAPEX Las Vegas 2025",
    stand: "100 sq ft · Sands Expo, Las Vegas",
    brief: "KYB, the shocks and struts brand, exhibited at AAPEX on a 10×10 footprint and wanted the booth to have far more presence than its size.",
    delivered: [
      "Fixed-price quote with no change orders on the show floor",
      "Booth design that made a 10×10 read like a 10×20",
      "Fabrication, graphics and installation in Las Vegas",
    ],
  },
  {
    slug: "santus-spice-master-prodexpo-moscow-2026",
    review: 2,
    expo: "prodexpo-moscow",
    client: "Santus / Spice Master",
    title: "Santus / Spice Master stand at Prodexpo Moscow 2026",
    stand: "36 sqm · Expocentre Moscow",
    brief: "The spice and seasonings brand needed a 36 sqm food stand at Prodexpo, Russia's largest food and beverage exhibition, without handling Moscow paperwork itself.",
    delivered: [
      "Expocentre builder accreditation handled by Stagehook",
      "Technical drawings prepared and submitted to the venue",
      "Graphics printed locally in Moscow",
      "Turnkey stand ready so the team only had to bring samples",
    ],
  },
  {
    slug: "glassco-analitika-expo-moscow-2025-2026",
    review: 3,
    expo: "analitika-moscow",
    client: "Glassco",
    title: "Glassco at Analitika Expo Moscow, two years running (2025 & 2026)",
    stand: "36 sqm (2025) · 48 sqm (2026) · Crocus Expo",
    brief: "Glassco, a laboratory glassware maker, came back to Analitika Expo a second year and wanted an upgraded stand without paying for a full new build.",
    delivered: [
      "2025: 36 sqm laboratory-equipment stand (A6077)",
      "2026: 48 sqm stand (A4103) with the structure re-skinned and upgraded",
      "Repeat-client pricing that came in below a new build",
    ],
  },
  {
    slug: "prinova-supplyside-west-2026",
    review: 4,
    expo: "supplyside-west-vegas",
    client: "PRINOVA",
    title: "PRINOVA nutritional ingredients booth at SupplySide West 2026",
    stand: "160 sq ft · Mandalay Bay, Las Vegas",
    brief: "PRINOVA, a nutritional ingredients and branded solutions company, needed a fast design turnaround and a Las Vegas build it could reuse at future shows.",
    delivered: [
      "3D concepts delivered in two days",
      "Build and installation in Las Vegas, with drayage and show-floor logistics coordinated",
      "Reusable structure designed for the following year's show",
    ],
  },
];

export const CASE_STUDIES = RAW.map((c) => {
  const expo = getExpoBySlug(c.expo);
  const images = [...new Set([expo?.heroImage, ...(expo?.gallery || []), ...(expo?.clients || []).map((x) => x.image)].filter(Boolean))];
  return { ...c, expoData: expo, images, quote: REVIEWS[c.review] };
});

export const getCaseStudyBySlug = (slug) => CASE_STUDIES.find((c) => c.slug === slug);
export const caseStudyForReview = (i) => CASE_STUDIES.find((c) => c.review === i);
